import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'fileVersionByChangedNumber' })
export class FileVersionByChangedNumberPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(version: string, changedNumber?: string): SafeHtml {
    if (!changedNumber || !version || version === changedNumber) {
      return version;
    }

    if (version.length !== changedNumber.length) {
      return changedNumber;
    }

    let result = '';
    for (let i = 0; i < version.length; i++) {
      // Add the changed character with styling if different; otherwise add the original version character
      result += (changedNumber[i] && version[i] !== changedNumber[i])
        ? `<span class="fw-bolder" style="color: #289fe7">${changedNumber[i]}</span>`
        : version[i];
    }

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
